export enum AuthRequestStates {
  AUTHENTICATION_IN_PROGRESS = 'AUTHENTICATION_IN_PROGRESS',
  OTP_VERIFICATION_PENDING = 'OTP_VERIFICATION_PENDING',
  MAGIC_LINK_SENT = 'MAGIC_LINK_SENT',
  LINK_SENT_OTP_VERIFICATION_PENDING = 'LINK_SENT_OTP_VERIFICATION_PENDING',
  OTP_VERIFIED = 'OTP_VERIFIED',
  LINK_VERIFIED = 'LINK_VERIFIED',
  SSO_AUTHENTICATED = 'SSO_AUTHENTICATED',
  ORGANIZATION_SWITCHER = 'ORGANIZATION_SWITCHER',
  ORGANIZATION_SIGNUP = 'ORGANIZATION_SIGNUP',
  ORGANIZATION_SWITCHER_SIGNUP = 'ORGANIZATION_SWITCHER_SIGNUP',
  ORGANIZATION_SELECTED = 'ORGANIZATION_SELECTED',
  ORG_USER_CREATED = 'ORG_USER_CREATED',
  AUTHENTICATION_COMPLETED = 'AUTHENTICATION_COMPLETED',
  INVALID_STATE = 'INVALID_STATE',
  NO_VALID_AUTH_REQUEST = 'NO_VALID_AUTH_REQUEST',
  AUTHENTICATION_FAILED = 'AUTHENTICATION_FAILED'
}
